import {putAll, takeLatestF} from '@fl/cmsch-fe-library';
import {SagaIterator} from 'redux-saga';
import {opt} from 'ts-opt';
import {call, put} from 'typed-redux-saga';

import {Api} from 'api/gen/Api';
import {t} from 'app/translations';
import {showBeError} from 'utils/show-be-error';

import {adminAction, GetManagementOrganizationDetailAction} from '../action';

function* execute({payload: {userRoleId}}: GetManagementOrganizationDetailAction): SagaIterator {
    const response = yield* call(Api.getUserProfileOrganizationRoleBinding, {userRoleId});

    if (response.isSuccess) {
        const optData = opt(response.data);
        yield* put(adminAction.getManagementOrganizationDetailSuccess(optData));
        yield* put(adminAction.setManagementOrganizationsUsers(optData.prop('user').toArray()));
        yield* put(adminAction.setManagementOrganizationsRoles(optData.prop('role').toArray()));
    } else {
        yield putAll(showBeError(response, t('admin')('loadDetail')));
    }
}
/** Runs the admin saga that loads the selected organization-management detail. */
export function* getManagementOrganizationDetailSaga(): SagaIterator {
    yield takeLatestF('admin/GET_MANAGEMENT_ORGANIZATION_DETAIL', execute);
}
